import React from 'react'
import { Row, Col, Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { setMassiveCalculationStep } from 'src/features'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'


const MassiveStepChanger = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const {
    step: currentStep,
    isNextButtonDisabled
  } = useAppSelector((state) => state.admin.massiveCalculation)

  const isVisible = (type: string = '') => {
    if (type === 'BACK') return currentStep !== 0
    return currentStep < 3
  }

  const handleStepChange = (newStep: number) => {
    dispatch(setMassiveCalculationStep(newStep))
  }

  return (
    <Row>
      <Col xs={12}>
        {isVisible('BACK') && (
          <Button
            type='default'
            className='radius-100'
            icon={<ArrowLeftOutlined />}
            size={'large'}
            onClick={() => handleStepChange(currentStep - 1)}
          >
            {t('card.Back')}
          </Button>
        )}
      </Col>
      <Col xs={12}>
        {isVisible() && (
          <Button
            type='primary'
            className='float-right radius-100'
            icon={<ArrowRightOutlined />}
            size={'large'}
            disabled={isNextButtonDisabled}
            onClick={() => handleStepChange(currentStep + 1)}
          >
            {t('card.Continue')}
          </Button>
        )}
      </Col>
    </Row>
  )
}

export default MassiveStepChanger
